import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'filedrop'
})
export class FileDropDirective {
    @HostBinding('class.fileover') fileOver: boolean;
}